// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"Share":"34f0e8eeafbd8e497121","ContentImport":"5ea444f17f6c6ae1b7f9","Queue":"05c34c968c7b27dd26dd","Stats":"013fc5f7ece712daaec6","Settings":"9ab43bb03f37e3caaafa","ClientApp":"ecd4db9ca6374636db50"}[chunkId] + ".bundle.js";
};